module.exports = __webpack_public_path__ + "img/phap-ly-doanh-nghiep.a259c83a.png";